import React, { useState, useEffect } from "react";
import { useMediaQuery } from "react-responsive";
import { useNavigate, useLocation } from "react-router-dom";
import { LifeBuoy } from "lucide-react";
import Sidebar from "./Sidebar";
import "./navbar.css";
import UserMenu from "./UserMenu";
import NotificacionesPopover from "./NotificacionesPopover";
import CandadoVentana from "./CandadoVentana";
import { detectarModuloDesdeURL } from "../../componentes/soporte/utils/mapeoModulosIntranet";
import { OCULTAR_SOPORTE } from "../../../config/flags";

function Navbar({ sidebar, setSidebar, isOpen, setOpen, setAutenticado }) {
  const [checked, setChecked] = useState(() => {
    const savedState = localStorage.getItem("sidebarExpanded");
    return savedState !== null ? JSON.parse(savedState) : true;
  });

  const isMobile = useMediaQuery({ maxWidth: 1024 });
  const navigate = useNavigate();
  const location = useLocation();

  const reportarProblema = () => {
    const modulo = detectarModuloDesdeURL(location.pathname);
    navigate(`/soporte/nuevo?categoria=intranet&modulo=${encodeURIComponent(modulo)}&url=${encodeURIComponent(location.pathname)}`);
  };

  useEffect(() => {
    if (!isMobile && isOpen) {
      setOpen(false);
    }
  }, [isMobile, isOpen, setOpen]);
  useEffect(() => {
    setSidebar(checked);
  }, [checked, setSidebar]);

  const handleChange = () => {
    const newCheckedState = !checked;
    setChecked(newCheckedState);
    setSidebar(newCheckedState);
    localStorage.setItem("sidebarExpanded", JSON.stringify(newCheckedState));
  };

  return (
    <>
      {isMobile ? (
        <Sidebar sidebar={sidebar} isMobile={isMobile} isOpen={isOpen} setOpen={setOpen} setAutenticado={setAutenticado} />
      ) : (
        <>
          <Sidebar sidebar={sidebar} />
          <div data-testid="app-navbar" className="fixed top-0 right-0 left-0 z-[1050] hidden lg:flex items-center justify-between bg-gray-50 px-2 py-1 shadow-[0_2px_6px_rgba(0,0,0,0.1)]">
            <div
              className={`check-menu form-switch ${sidebar ? "expanded" : "collapsed"}`}
            >
              <label className="switch">
                <input
                  type="checkbox"
                  checked={checked}
                  onChange={handleChange}
                />
                <span className="slider"></span>
              </label>
            </div>
            <div className="flex items-center gap-2">
              {/* TEMPORAL pre-prod: botón oculto vía flag OCULTAR_SOPORTE. */}
              {!OCULTAR_SOPORTE && (
                <button
                  type="button"
                  onClick={reportarProblema}
                  title="Reportar un problema con la intranet"
                  className="inline-flex items-center gap-1.5 rounded-lg border border-blue-200 bg-blue-50 px-3 py-1.5 text-xs font-medium text-[#003c66] hover:bg-blue-100 transition-colors"
                >
                  <LifeBuoy size={14} />
                  Reportar problema
                </button>
              )}
              {/* Fase A1 · el indicador de la ventana del segundo factor vive donde vive la
                  identidad, no en cada pantalla: la ventana es de quien mira. */}
              <CandadoVentana />
              <NotificacionesPopover />
              <UserMenu setAutenticado={setAutenticado} />
            </div>
          </div>
        </>
      )}
    </>
  );
}

export default Navbar;
